import React, { useState } from 'react';
import { HexColorPicker } from 'react-colorful';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';

interface FormikColorPickerProps {
  type: string;
  name: string;
  label: string;
  fieldValue: {
    value: string;
  };
  handleChange: (color: string) => void;
}

const FormikColorPicker: React.FC<FormikColorPickerProps> = ({
  fieldValue,
  handleChange,
  type,
  name,
  label
}) => {
  const [isFieldFocused, setIsFieldFocused] = useState(false);
  return (
    <Box className="App">
      <TextField
        fullWidth
        label={label}
        type={type}
        name={name}
        value={fieldValue?.value}
        onChange={(e) => handleChange(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <Box
                sx={{
                  width: 100,
                  height: 40,
                  background: fieldValue?.value
                }}
              ></Box>
              <IconButton
                sx={{ margin: 0 }}
                onClick={() => setIsFieldFocused(!isFieldFocused)}
              >
                <ColorLensIcon fontSize="large" />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <br />
      <br />
      {isFieldFocused && (
        <HexColorPicker
          style={{ minWidth: '270px' }}
          color={fieldValue?.value}
          onChange={handleChange}
        />
      )}
    </Box>
  );
};

export default FormikColorPicker;
